import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ViewModeEnum, AlertDialogTypeEnum } from '../../../_enums/_index';
import { TermModel, ServiceTypeModel } from '../../../_models/_index';
import { TermService } from '../../../services/_index';
import { InfraService } from '../../../services/_index';

@Component({
  selector: 'app-term-dialog',
  templateUrl: './term-dialog.component.html',
  styleUrls: ['./term-dialog.component.css']
})
export class TermDialogComponent implements OnInit {

    dialogHeader: string;
    viewMode: ViewModeEnum;
    term: TermModel = new TermModel();
    serviceTypeList: ServiceTypeModel[];

    constructor(private termService: TermService,
        private dialog: MatDialog,
        private infraService: InfraService,
        public dialogRef: MatDialogRef<TermDialogComponent>) { }

    ngOnInit() {
        this.loadServiceType();
    }

    getSaveText() {
        switch (this.viewMode) {
            case ViewModeEnum.Add:
                return "הוסף";
            case ViewModeEnum.Edit:
                return "עדכן";
        }
    }

    save() {
        if (this.viewMode == ViewModeEnum.Add) {
            this.add();
        }
        else {
            this.edit();
        }
    }

    private add() {
        this.termService.addTerm(this.term).then((result: TermModel) => {
            if (result) {
                this.dialogRef.close(result);
            }
        });
    }

    private edit() {
        this.termService.editTerm(this.term).then((result: TermModel) => {
            if (result) {
                this.dialogRef.close(result);
            }
        });
    }

    private isEditMode() {
        return this.viewMode == ViewModeEnum.Edit;
    }

    private loadServiceType() {
        this.infraService.getServiceType().then(result => {
            this.serviceTypeList = result;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/terms/term-dialog/term-dialog.component.ts